import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

import { useStyles } from "./ResultTable.css";

class ResultTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Subject Name" },
        { name: "Theory" },
        { name: "Practical" },
        { name: "Obtained Marks" },
      ],
      failRemarks: [
        "Do your best next time!",
        "You can do much better, Keep Working Hard",
      ],
      passRemarks: ["Congratulations! You can do better than this", ""],
    };
  }

  render() {
    const { classes, marks } = this.props;
    let total = 0;
    marks.map((data) => (total = total + data.theory + data.practical));
    let finalStatus = marks.find((data) => data.resultStatus === "Fail")
      ? "Fail"
      : "Pass";
    this.state.failRemarks.sort(() => Math.random() - 0.5);
    this.state.passRemarks.sort(() => Math.random() - 0.5);
    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {this.state.column.map((column, index) => (
                <TableCell
                  key={index}
                  align="center"
                  style={{ fontWeight: "bold" }}
                  className={classes.tableStyle}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {marks.map((subject, index) => (
              <TableRow key={index} className={classes.tableStyle}>
                <TableCell align="center" className={classes.tableStyle}>
                  {index + 1}
                </TableCell>
                <TableCell align="center" className={classes.tableStyle}>
                  {subject.subjectName}
                  {subject.resultStatus === "Fail" && "*"}
                </TableCell>
                <TableCell align="center" className={classes.tableStyle}>
                  {subject.theory}
                </TableCell>
                <TableCell align="center" className={classes.tableStyle}>
                  {subject.practical}
                </TableCell>
                <TableCell align="center" className={classes.tableStyle}>
                  {subject.theory + subject.practical}
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell
                align="center"
                colSpan={4}
                className={classes.tableStyle}
              >
                Total
              </TableCell>
              <TableCell align="center" className={classes.tableStyle}>
                {total}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center" className={classes.tableStyle}>
                Result
              </TableCell>
              {finalStatus === "Pass" ? (
                <TableCell
                  align="center"
                  style={{ color: "green" }}
                  className={classes.tableStyle}
                >
                  Pass
                </TableCell>
              ) : (
                <TableCell
                  align="center"
                  style={{ color: "red" }}
                  className={classes.tableStyle}
                >
                  Fail
                </TableCell>
              )}
              <TableCell
                align="center"
                colSpan={3}
                className={classes.tableStyle}
              >
                Remarks:
                {finalStatus === "Fail"
                  ? this.state.failRemarks[0]
                  : this.state.passRemarks[0]}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default withStyles(useStyles)(ResultTable);
